import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SliderContainer from './components/SliderContainer';
import { smallZoomIcon } from '../Svgs';
import { forEach } from 'lodash';
import './index.scss';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import defer from 'lodash/defer';

const collapseIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 -3 18 18"
  >
    <path
      fillRule="nonzero"
      d="M6.298 5.138L1.213.192a.523.523 0 0 0-.734 0L.173.495a.508.508 0 0 0 0 .724L4.588 5.5.177 9.78a.508.508 0 0 0 0 .725l.306.303c.203.2.531.2.734 0l5.085-4.946a.512.512 0 0 0-.004-.724zm5.525.724l-5.085 4.946c-.203.2-.53.2-.734 0l-.306-.303a.508.508 0 0 1 0-.724L10.114 5.5 5.702 1.22a.508.508 0 0 1 0-.725L6.01.192c.203-.2.53-.2.733 0l5.085 4.946c.199.2.199.524-.004.724z"
    />
  </svg>
);

/**
 * Draws zoom controller
 * */
class Zoom extends PureComponent {
  static displayName = 'Zoom';

  static propTypes = {
    playerContainer: PropTypes.instanceOf(Element),
  };

  static defaultProps = {
    playerContainer: document,
  };

  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
    };

    this.onTransitionEnd = this.onTransitionEnd.bind(this);
    this.onQuestionsTransitionEnd = this.onQuestionsTransitionEnd.bind(this);
    this.onToggleClick = this.onToggleClick.bind(this);
    this.repositionNextArrow = this.repositionNextArrow.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onItemLoad = this.onItemLoad.bind(this);
    this.setBottomNavPos = this.setBottomNavPos.bind(this);
  }

  componentDidMount() {
    const { app, playerContainer } = this.props;

    this.questionContainer = playerContainer.querySelector('.slides-container');
    this.questionsControl = playerContainer.querySelector('.slides-control');
    this.bottomNav = playerContainer.querySelectorAll(
      '.slides-container>button',
    );
    this.containerElement = playerContainer.querySelector('.Zoom--container');
    const containerElementTop =
      this.containerElement.getBoundingClientRect().top;
    this.containerElementBoundaries = {
      top: containerElementTop,
      bottom: containerElementTop + this.containerElement.offsetHeight,
    };
    this.bottomPrevNav = playerContainer.querySelector(
      '.slides-container>.item-prev',
    );
    this.bottomNextNav = playerContainer.querySelector(
      '.slides-container>.item-next',
    );
    if (this.bottomNextNav) {
      this.bottomNextNavHeight = this.bottomNextNav.offsetHeight;
      window.addEventListener('scroll', this.onScroll);
    }
    this.containerElement.addEventListener(
      'transitionend',
      this.onTransitionEnd,
    );
    this.questionsControl.addEventListener(
      'transitionend',
      this.onQuestionsTransitionEnd,
    );

    app.on('item:load', this.onItemLoad);
  }

  componentWillUnmount() {
    const { app } = this.props;

    this.containerElement.removeEventListener(
      'transitionend',
      this.onTransitionEnd,
    );
    this.questionsControl.removeEventListener(
      'transitionend',
      this.onQuestionsTransitionEnd,
    );
    this.questionContainer.style.height = null;

    forEach(this.bottomNav, (element) => {
      element.style.top = null;
      element.style.right = null;
    });

    window.removeEventListener('scroll', this.onScroll);

    app.off('item:load', this.onItemLoad);
  }

  /**
   * Triggered after tab container finished moving
   * @param {object} event Object event handler
   * */
  onTransitionEnd() {
    this.repositionNextArrow({
      end: true,
    });
  }

  /**
   * Triggered after tab container finished moving
   * @param {object} event Object event handler
   * */
  onQuestionsTransitionEnd(event) {
    if (event.propertyName === 'transform') {
      this.setBottomNavPos();
      this.repositionNextArrow({
        end: true,
      });
    }
  }

  /**
   * On click handler for expand handler
   * */
  onToggleClick(e) {
    e.stopPropagation();
    this.repositionNextArrow({
      start: true,
    });
    this.setState(({ isExpanded }) => ({
      isExpanded: !isExpanded,
    }));
  }

  /**
   * Reposition next arrow related to zoom container
   * @param {object} props
   * */
  repositionNextArrow(props) {
    if (this.bottomNextNav) {
      const navArrowTop = this.bottomNextNav.getBoundingClientRect().top;
      let containerElementTop = this.containerElementBoundaries.top;
      /**
       * Remove 15px from container top - being added while element is scaled
       * */
      if (this.containerElement.classList.contains('is-expanded')) {
        containerElementTop -= 15;
      }

      if (
        navArrowTop + this.bottomNextNavHeight >= containerElementTop &&
        navArrowTop <= this.containerElementBoundaries.bottom
      ) {
        if (props.start) {
          this.bottomNextNav.style.visibility = 'hidden';
          this.bottomPrevNav.style.visibility = 'hidden';
        } else if (props.end) {
          this.bottomNextNav.style.visibility = 'visible';
          this.bottomPrevNav.style.visibility = 'visible';

          this.bottomNextNav.style.right = `${
            this.containerElement.offsetWidth + 20
          }px`;
        }
      } else {
        this.bottomNextNav.style.right = null;
      }
    }
  }

  /**
   * On scroll event handler
   * */
  onScroll() {
    this.repositionNextArrow({
      end: true,
    });
  }

  /**
   * On item load learnosity event handler
   * */
  onItemLoad() {
    this.setBottomNavPos();

    this.repositionNextArrow({
      end: true,
    });
  }

  /**
   * Set bottom navigation arrows position
   * */
  setBottomNavPos() {
    if (this.bottomNextNav) {
      const scale =
        this.questionsControl.style.transform.match(/scale\((.+)\)/);
      const isZoomed = scale && scale[1] > 1;

      if (isZoomed) {
        this.questionContainer.style.height = null;
        let { height } = this.questionsControl.getBoundingClientRect();

        /**
         * Remove 10px if item has no shared passages
         * */
        if (document.querySelector('.has-passages')) {
          height -= 10;
        }

        this.questionContainer.style.height = `${height}px`;

        forEach(this.bottomNav, (element) => {
          element.style.top = `${height}px`;
        });
      } else {
        this.questionContainer.style.height = null;
        forEach(this.bottomNav, (element) => {
          element.style.top = null;
        });
      }
    }
  }

  render() {
    const { isExpanded } = this.state;
    const { buttonRef, playerContainer } = this.props;
    const classNames = cn('Zoom--container', { 'is-expanded': isExpanded });

    return (
      <div className={classNames}>
        <A11y>
          <button
            aria-expanded={isExpanded}
            aria-controls="zoomSlider"
            aria-label={isExpanded ? 'Collapse Zoom' : 'Zoom'}
            className="Zoom--expander"
            onClick={this.onToggleClick}
            ref={buttonRef}
          >
            {isExpanded
              ? collapseIcon({ 'aria-hidden': true })
              : smallZoomIcon({ 'aria-hidden': true })}
          </button>
        </A11y>
        <SliderContainer
          isAvailable={isExpanded}
          onMouseOver={(e) => e.stopPropagation()}
          onFocus={() => false}
          onClose={() => {
            this.setState((state) => ({
              ...state,
              isExpanded: false,
            }));
            // due to badly nested buttons we can not focus back on the buttonRef, we need to actually find a
            // toolkit button somewhere higher in the DOM :(
            defer(() => {
              document.querySelector('.zoomButton').focus();
            });
          }}
          playerContainer={playerContainer}
        />
      </div>
    );
  }
}

export default Zoom;
